<section fxLayoutAlign="end center">
  <sbnb-close [border]="true" (click)="dialogRef.close()"></sbnb-close>
</section>

<section *ngIf="directSub$ | async as sub" fxFlexFill fxLayout fxLayoutAlign="center center">
  <div *ngIf="!loading" class="fs-dialog-contents" fxLayout="column" fxLayoutGap="12px">
    <h1>Switch to {{ dialogData.plan | directSubscriptionDescriptionFromKey }}</h1>

    <ul>
      <li>
        <strong>Existing bookings are not affected.</strong>
        The Direct subscription plan that was in place when the booking was requested determines how the booking is
        handled.
      </li>

      <li *ngIf="dialogData.plan === DirectPlan.Basic">
        You will need to add all
        <strong>taxes</strong>
        Hospitable should calculate and collect for you on the property page of each property.
      </li>

      <li *ngIf="dialogData.plan === DirectPlan.Premium">
        All
        <strong>new bookings</strong>
        for properties connected to a Premium payout method will include integrated tax calculation, guest vetting,
        damage protection, and other Premium features.
      </li>

      <li *ngIf="needsToAddStripeAccount">
        You will need to
        <strong>connect a Stripe account</strong>
        , and set it as your default Basic payout method before switching.
      </li>

      <li *ngIf="needsToAddAdyenAccount">
        You will need to
        <strong>connect a bank account</strong>
        before switching.
      </li>
    </ul>

    <sbnb-button
      *ngIf="!needsToAddStripeAccount && !needsToAddAdyenAccount"
      (clicked)="switchPlan(sub.trial, dialogData.plan)"
      [loading]="switching">
      Switch to {{ dialogData.plan | directSubscriptionDescriptionFromKey }}
    </sbnb-button>

    <ng-container *ngIf="needsToAddAdyenAccount">
      <sbnb-button
        [routerLink]="['/direct/payouts/new/adyen']"
        [queryParams]="{ redirect: 'switch' }"
        (clicked)="dialogRef.close()"
        type="primary-teal">
        Add a payout method
      </sbnb-button>
      <span class="card__collapsed-helper-text">A payout method is required to switch to Direct Premium.</span>
    </ng-container>

    <ng-container *ngIf="needsToAddStripeAccount">
      <sbnb-button
        [routerLink]="['/direct/payouts/new/stripe-oauth']"
        [queryParams]="{ redirect: 'switch' }"
        (clicked)="dialogRef.close()"
        type="primary-teal">
        Add a Stripe account
      </sbnb-button>
      <span class="card__collapsed-helper-text">
        A Stripe account is required before you can switch to Direct Basic.
      </span>
    </ng-container>
  </div>

  <mat-spinner *ngIf="loading" diameter="32"></mat-spinner>
</section>
